import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { Spinner } from "@volca/ui/components/ui/spinner";
import { Stack } from "@volca/ui/components/ui/stack";
import { useGetMyUser } from "@/user/query";
import { isAdmin } from "./user/utils";

const TestError = () => {
  const { data: user, isLoading } = useGetMyUser();

  useEffect(() => {
    // This will throw an error when the component mounts
    if (!!user && isAdmin(user?.role)) {
      throw new Error("This is a test error to verify the error boundary!");
    }
  }, [user]);

  if (isLoading) {
    return (
      <Stack
        align="start"
        gap={4}
        className="h-full w-full items-center justify-center"
      >
        <Spinner layout="centered" />
      </Stack>
    );
  }

  if (!!user && !isAdmin(user?.role)) {
    return <Navigate to="/" />;
  }

  return <div>This won't be rendered</div>;
};

export default TestError;
